// ----------------------------------------------------------------------------
// Template: Cart
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import './ajax-cart-page';
import 'snippets/cart-js/cart-js';
import 'snippets/mini-cart/mini-cart';
import 'snippets/tooltip/tooltip';

import 'sections/header/header';
import 'sections/footer/footer';

// Styles
import './_cart.scss';

$(document).ready(function() {

    if(Loop.status === 'active') {

        if (Shopify.shop == "dishandduer.myshopify.com") { // US Store
            Loop.setKey('1850572a5a9f74a567a9d64958c9d3832879e89d');
        } else { // CA Store
            Loop.setKey('c0f81247463e1d8c5dc4eed930900eaa684iudhiu');
        }

        $('body').on('click', '.button--checkout', function(event){
            event.preventDefault();

            var cartItems = [];
            $('.rebuy__cart__line-item').each(function(index, value){

            if ($(this).attr('data-variant-id') !== null && $(this).attr('data-variant-id') !== '') {

                if($(this).attr('data-cart-quantity') !== null && $(this).attr('data-cart-quantity') !== '') {
                    var $loopCount = parseInt($(this).attr('data-cart-quantity'));
                } else {
                    var $loopCount = $(this).find('.rebuy__cart__quantity').val()
                }

                for (var i=0; i<$loopCount; i++) {
                    cartItems.push($(this).attr('data-variant-id'));
                }
            }
            });
            Loop.submit(cartItems);
        });
    } else {  
        document.addEventListener('rebuy:smartcart.ready', function(event){
            const SmartCart = window.Rebuy.SmartCart;
            $('body').on('click', '.button--checkout', function(event){
                SmartCart.checkout();
            });
        });  
    }
})
